<div class="logo">
    <img [src]="clientTheme.logoSmallUri" alt="Rocket Close Clear Sign Logo"/>
</div>
<div class="container">
    <h1 class="title">We're working to get you back on track</h1>
    <p class="text">We are currently unable to complete digital closings on Clear Sign. We sincerely apologize for the inconvenience. Please know that our team is actively working to resolve the issue. We appreciate your patience and understanding during this time.</p>
    <hr>
    <p class="section-title">Borrowers:</p>
    <ul>
        <li>
            <p class="instructions">Please call your signing agent for guidance, or expect a call from them before your scheduled closing time.</p>
        </li>
    </ul>    
    <p class="section-title">Signing Agents:</p>
    <ul>
        <li>
            <p class="instructions">You may have already received, or will soon receive, communication from us with next steps. If your signing appointment is scheduled for now or in the immediate future, please reach out to the borrower(s) as soon as possible. Confirm their readiness and provide any support they may need to ensure a smooth and stress-free experience.</p>
        </li>
    </ul>
    <hr>
    <p class="text">We appreciate your understanding as we work to restore service swiftly.</p>
</div>

